export const IconLupaIncrease: {
  name: 'icon_lupa_increase-c924688efc47'
} = {
  name: 'icon_lupa_increase-c924688efc47'
}
